import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import nl from "./locales/nl.json";
import fr from "./locales/fr.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nl: { translation: nl },
      fr: { translation: fr },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "nl", "fr"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "trustline_lang",
    },
  });

const syncHtmlLang = (lng) => { if (typeof document !== "undefined") document.documentElement.lang = (lng || "en").slice(0, 2); };
syncHtmlLang(i18n.language);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN", country: "GB" },
  { code: "nl", label: "Nederlands", short: "NL", country: "NL" },
  { code: "fr", label: "Français", short: "FR", country: "FR" },
];
